import React from "react";
// MUI
import { Grid2 } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import StarBorderPurple500OutlinedIcon from "@mui/icons-material/StarBorderPurple500Outlined";
// Styling
import styles from "./SelectType.module.scss";
// Local imports
import InstallationType from "../InstallationType/InstallationType";
import {
  PerformanceSites,
  selectedTypeData,
} from "../ConstantData/CreateSiteConstantData";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";

export default function SelectType(props) {
  const {
    selectedType,
    setSelectedType,
    installationType,
    setInstallationType,
    onInstallationTypeSelect,
    performQuantity,
    performButton,
    setPluginCard,
    isParentOrg,
    orgId,
    dedicatedHosting,
  } = props;

  const handleSelectType = (index, comingSoon) => {
    if (comingSoon) return;
    if (selectedType === index) {
      setSelectedType(null);
    } else {
      setSelectedType(index);
    }
    if (selectedType !== index) {
      setPluginCard([]);
    }
  };

  const availablity =
    performQuantity.quantity * performQuantity.limitOrAvailablity;
  const remainingQuantity = availablity - performQuantity?.used;
  const reachedLimit = availablity === performQuantity?.used;

  return (
    <>
      <Grid2 className={styles.SelectType}>
        <Grid2 className={styles.header}>Select Type</Grid2>
        <Grid2 className={styles.SelectTypeFlexBox}>
          {selectedTypeData
            .filter((item) => {
              // performance sites are not offered from here any more
              if (item.title === "Performance site") {
                return false;
              }
              return true;
            })
            .map(({ icon: Icon, title, description, comingSoon }, index) => (
              <Grid2
                key={index}
                className={`${styles.Container} ${
                  selectedType === index ? styles.active : ""
                }`}
                onClick={() => handleSelectType(index, comingSoon)}
              >
                {comingSoon && (
                  <Grid2 className={styles.star}>
                    <StarBorderPurple500OutlinedIcon />
                    <Grid2 className={styles.Comingsoon}>Coming soon</Grid2>
                  </Grid2>
                )}
                {selectedType === index && (
                  <Grid2 className={styles.tickBox}>
                    <CheckOutlinedIcon className={styles.Check} />
                  </Grid2>
                )}
                <Icon />
                <Grid2>
                  <Grid2 className={styles.title}>
                    {title}
                    {title === "Performance site" ? (
                      <Grid2 className={styles.performQuantity}>
                        (
                        {reachedLimit
                          ? remainingQuantity
                          : remainingQuantity
                          ? remainingQuantity
                          : performQuantity.quantity}
                        )
                      </Grid2>
                    ) : (
                      ""
                    )}
                  </Grid2>
                  <Grid2 className={styles.subHeader}>{description}</Grid2>
                </Grid2>
              </Grid2>
            ))}
        </Grid2>
        {selectedType === 0 ? (
          <InstallationType
            installationType={installationType}
            setInstallationType={setInstallationType}
            onInstallationTypeSelect={onInstallationTypeSelect}
            dedicatedHosting={dedicatedHosting}
            orgId={orgId}
          />
        ) : selectedType === 1 &&
          (performQuantity.quantity === 0 || reachedLimit) ? (
          <Grid2 className={styles.EmptyButton}>
            <Grid2>
              <Grid2 className={styles.header}>{PerformanceSites.title}</Grid2>
              <Grid2 className={styles.description}>
                {performQuantity.limitOrAvailablity !== 0
                  ? PerformanceSites.description1
                  : PerformanceSites.description}
              </Grid2>
            </Grid2>
            {(orgId === -1 || isParentOrg) && (
              <CustomButton
                className={styles.buttonOnclick}
                onClick={performButton}
              >
                {PerformanceSites.button}
              </CustomButton>
            )}
          </Grid2>
        ) : selectedType === 1 && availablity > 0 ? (
          <InstallationType
            installationType={installationType}
            setInstallationType={setInstallationType}
            onInstallationTypeSelect={onInstallationTypeSelect}
            dedicatedHosting={dedicatedHosting}
            orgId={orgId}
          />
        ) : null}
      </Grid2>
    </>
  );
}
